import { GET_COUNTRIES, GET_STATES, GET_CITIES, CLEAR_COUNTRIES, CLEAR_STATES, CLEAR_CITIES } from '../actions/types'

const initialRegisterEmailState = {
    countries: [],
    states: [],
    cities: [],
}

export default function (state = initialRegisterEmailState, action) { //lo que se manda de personasAction en el dispatch es el action
    switch (action.type) {
        case GET_COUNTRIES:
            return { ...state, countries: action.payload }
        case GET_STATES:
            return { ...state, states: action.payload }
        case GET_CITIES:
            return { ...state, cities: action.payload }
            case CLEAR_COUNTRIES:
                return { ...state, countries: [] }
            case CLEAR_STATES:
                return { ...state, states: [] }
            case CLEAR_CITIES:
                return { ...state, cities: [] }
        default:
            return state

    }
}